import { InitApp, attachState } from '@dolnpm/react-redux-init-app'
import HeaderContainer from "./components/header-container/HeaderContainer.jsx"
import theme from 'config/theme/theme.js'

import './static.sass'
import {extractLink} from "@dolnpm/link-extractor";

const account = JSON.parse(document.getElementById('account').getAttribute('data'))


InitApp({theme})(HeaderContainer, {})('header')